import type { ReactNode } from 'react';

export const symbol_tv_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M880-780v495q0 15-9.32 22.5t-20.5 7.5q-11.18 0-20.68-7.68-9.5-7.69-9.5-22.32v-495H304q-15 0-22.5-9.32t-7.5-20.5q0-11.18 7.5-20.68T304-840h516q24 0 42 18t18 42Zm-722-60 60 60h-78v520h512L50-862q-9-9-8.5-21.5T51-905q9-9 21-9t21 9l765 764q9 9 9 21t-9 21q-9 9-21.5 9T815-99L713-200h-83v50q0 12.75-8.62 21.37Q612.75-120 600-120H360q-12.75 0-21.37-8.63Q330-137.25 330-150v-50H140q-24 0-42-18t-18-42v-520q0-24 18.5-42t41.5-18h18Zm263 350Zm143-28Z"
		/>
	</svg>
);
